import React from "react";
import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../../../assets/icons";
import { editRecurringInvoice } from "../../../../backend-services";
import { showToast } from "../../../../utils/toastUtils";

interface DeleteServicePromptProps {
  setShowPrompt: (show: boolean) => void;
  id?: string;
  fetchInvoiceData: () => Promise<void>;
}

const DeletePrompt = ({
  setShowPrompt,
  id,
  fetchInvoiceData,
}: DeleteServicePromptProps) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const navigate = useNavigate();

  const data = {
    reoccurringStatus: "cancelled",
  };

  const handleEditRecurringInvoiceStatus = async (id: any, data: any) => {
    try {
      setIsLoading(true);
      const response = await editRecurringInvoice({ id, data });
      setIsLoading(false);
      showToast("Recurring Invoice Cancelled Successfully", "success");
      fetchInvoiceData();
      setShowPrompt(false);
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage("Unable to update invoice.");
      if (
        error.response &&
        (error.response.status === 400 || error.response.status === 500)
      ) {
        navigate("/error");
      }
    }
  };

  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block md:block px-[1em]">
        <div className="flex justify-between">
          <h1 className="font-semibold text-[25px]">Cancel recurrence? </h1>
          <button
            className=" shadow-sm py-[0.2em] bg-[#F4F7FF] pr-4"
            aria-label="Close modal"
            onClick={() => setShowPrompt(false)}
          >
            <CloseIcon color="black" />
          </button>
        </div>
        <div className="flex justify-center mt-[13px] ">
          <h1 className="text-[18px]">
            Are you sure you want to cancel the recurrence of
            <br />
            <span>this invoice? </span>
          </h1>
        </div>
        <div
          role="form"
          className="flex w-full gap-6 mt-8"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="w-1/2">
            <button
              onClick={() => setShowPrompt(false)}
              className="w-full rounded-[4px] h-[48px] bg-[#FFFFFF] text-[#044E97] font-semibold border border-blue-500"
            >
              Go back
            </button>
          </div>
          <div className="w-1/2">
            <button
              onClick={() => handleEditRecurringInvoiceStatus(id, data)}
              className={`w-full rounded-[4px] h-[48px] font-semibold ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#FB0303] text-white"} transition-colors`}
              disabled={isLoading}
            >
              {isLoading ? "Canceling..." : "Yes, Cancel"}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 rounded-t-full">
        <div className="bg-white p-4">
          <div className="flex w-full justify-end">
            <div onClick={() => setShowPrompt(false)}>
              <CloseIcon color="#212121" />
            </div>
          </div>
          <h1 className="font-semibold text-[20px] text-center">
            Cancel recurrence?{" "}
          </h1>
          <div className="flex justify-center mt-[13px] ">
            <h1 className="text-[16px] text-center">
              Are you sure you want to cancel the recurrence
              <br />
              <span>of this invoice? </span>
            </h1>
          </div>
          <div
            role="form"
            className="flex w-full gap-6 mt-8"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="w-1/2">
              <button
                onClick={() => setShowPrompt(false)}
                className="w-full rounded-[4px] h-[48px] bg-[#FFFFFF] text-[#044E97] font-semibold border border-blue-500"
              >
                Go back
              </button>
            </div>
            <div className="w-1/2">
              <button
                onClick={() => handleEditRecurringInvoiceStatus(id, data)}
                className="w-full rounded-[4px] h-[48px] bg-[#FB0303] text-white  font-semibold"
              >
                {isDeleting ? "Canceling..." : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { DeletePrompt };
